import { render } from "./PaginationItem.vue?vue&type=template&id=c2712208&ts=true"
import script from "./PaginationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2712208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2712208', __exports__)) {
    api.reload('c2712208', __exports__)
  }
  
  module.hot.accept("./PaginationItem.vue?vue&type=template&id=c2712208&ts=true", () => {
    api.rerender('c2712208', render)
  })

}


export default __exports__